/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Unlock_AriaInputs */

const en_explorer_info_unlock_aria = /** @type {(inputs: Explorer_Info_Unlock_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock`)
};

const fr_explorer_info_unlock_aria = /** @type {(inputs: Explorer_Info_Unlock_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deverrouiller`)
};

const de_explorer_info_unlock_aria = /** @type {(inputs: Explorer_Info_Unlock_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entsperren`)
};

const it_explorer_info_unlock_aria = /** @type {(inputs: Explorer_Info_Unlock_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sbloccare`)
};

const ru_explorer_info_unlock_aria = /** @type {(inputs: Explorer_Info_Unlock_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разблокировать`)
};

const es_explorer_info_unlock_aria = /** @type {(inputs: Explorer_Info_Unlock_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubrir`)
};

const zh_cn2_explorer_info_unlock_aria = /** @type {(inputs: Explorer_Info_Unlock_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开锁`)
};

const ja_explorer_info_unlock_aria = /** @type {(inputs: Explorer_Info_Unlock_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロック解除`)
};

const hi_explorer_info_unlock_aria = /** @type {(inputs: Explorer_Info_Unlock_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनलॉक`)
};

const pt_pt2_explorer_info_unlock_aria = /** @type {(inputs: Explorer_Info_Unlock_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloquear`)
};

/**
* | output |
* | --- |
* | "Unlock" |
*
* @param {Explorer_Info_Unlock_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_unlock_aria = /** @type {((inputs?: Explorer_Info_Unlock_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Unlock_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_unlock_aria(inputs)
	if (locale === "de") return de_explorer_info_unlock_aria(inputs)
	if (locale === "it") return it_explorer_info_unlock_aria(inputs)
	if (locale === "ru") return ru_explorer_info_unlock_aria(inputs)
	if (locale === "es") return es_explorer_info_unlock_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_unlock_aria(inputs)
	if (locale === "ja") return ja_explorer_info_unlock_aria(inputs)
	if (locale === "hi") return hi_explorer_info_unlock_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_unlock_aria(inputs)
	return en_explorer_info_unlock_aria(inputs)
});